import "./StartYourQuote.module.css";
import MainHeader from "@/reusable_sections/Header";
import JoinOurTable from "./sections/JoinOurTable";
import PoweringYourSuburb from "./sections/PoweringYourSuburb";
import CommonQuestions from "./sections/CommonQuestions";
import DealershipHubFooter from "@/reusable_sections/Footer";
export default function StartYourQuotePage() {
  return <div>
      <MainHeader />
      <JoinOurTable />
      <PoweringYourSuburb />
      <CommonQuestions />
      <DealershipHubFooter />
    </div>;
}